import { AwsRum } from 'aws-rum-web'
import { config } from './config'

export const initAppMonitor = () => {
  try {
    const opts =
      config.front
        .appMonitorConfig
    if (opts) {
      new AwsRum(opts.id, opts.version, opts.region, opts.config)
    }
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}
